import { RadioStyles } from '../radio-styles';

export class RadioOptionModel {
  id?: string;
  value: any;
  label: string;
}
export abstract class RadioModel implements RadioStyles {
  id?: string;
  formControlName?: string;
  options?: RadioOptionModel[];

  color?: string; // NOTE: to make the radio color editable,
  // the radio button itself would
  // Need to be re-done so for now, unless this is explicity listed as
  // a requirement Color is NOT editable
  radioSize?: number;
  fontWeight?: number;
  fontFamily?: string;
}
